(() => {
  // Selectors removed from the sticky clone. Tune to your actual markup.
  const STRIP = [
    '.fts-vat-toggle',
    '[data-vat-toggle]',
    'shopify-payment-terms',
    '.shopify-payment-terms',
    '.fts-price__installments',
    'button'
  ].join(',');

  const init = () => {
    const bar = document.querySelector('[id^="fts-sticky-bar-"]');
    if (!bar) return;

    const sectionId = bar.id.replace('fts-sticky-bar-', '');
    const target = bar.querySelector('.fts-sticky-bar__price');
    const source = document.getElementById(`price-${sectionId}`);

    if (!target || !source) {
      console.warn('[fts-sticky] not wired', { sectionId, target: !!target, source: !!source });
      return;
    }

    const sync = () => {
      const clone = source.cloneNode(true);
      clone.querySelectorAll(STRIP).forEach(n => n.remove());
      // never duplicate ids into the document
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach(n => n.removeAttribute('id'));
      target.replaceChildren(...clone.childNodes);
    };

    sync();

    new MutationObserver(sync).observe(source, {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['class']
    });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();